import moment from "moment";
import React, { Fragment, useState } from "react"
import 'react-image-lightbox/style.css';
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown } from "reactstrap";
import iconSub from '../../../assets/images/icon-sub.png';
import profilePic from '../../../assets/images/users/no-img.jpg';
import ModalPopup from "../../../components/ModalPopup";
import NavTabNutri from "../../../components/NavTabNutri";
import RowEmpty from "../../../components/RowEmpty";
import PriceUtils from "../../../helpers/PriceUtils";
import ReceiptsAdd from "../../receipts/ReceiptsAdd";
import { getDetailSource } from "../../supplier/components/SupplierTab";
import TextUtils from "../../../helpers/TextUtils";
import { ActionStatus, ActionType } from "../../reception/components/ActionAdd";
import IconArrowDown from '../../../assets/images/ic_arrow_down.png';
import IconArrowUp from '../../../assets/images/ic_arrow_up.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import IconPlus from '../../../assets/images/icon-plus.png';
import { checkRole } from "../../../helpers/Roles";

const TABS = [
    {
        value:'debt',
        label: "Công nợ"
    },
    // {
    //     value:'examination',
    //     label: "Lịch sử khám"
    // },
   
]


const CustomereExamination = (props: any) => {
    const { data } = props
    const router = useHistory()

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-center" style={{ minWidth: 60}}>Mã phiếu</th>
                    <th className="text-center" style={{ minWidth: 60 }}>Cơ sở (Kho)</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Tổng tiền nhập</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Trạng thái</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày nhập</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        if (!data || data?.length === 0) {
            return <RowEmpty column={5} title="Chưa có dữ liệu nhập hàng nào!" />;
        }
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        const gotoDetail = (item:any) => {
            router?.push(`/stockimport/${item?.id}/view`)
        }
        return (
            <tr key={`${item?.id}-${index}`} onClick={() => gotoDetail(item)}>
                <td><Link to={`/stockimport/${item?.id}/view`}>{item?.code}</Link></td>
                <td>{item?.branch_id?.name}</td>
                <td className="text-center">{item?.sub_total ? PriceUtils.format(Number(item?.sub_total) , '') : '---'}</td>
                <td className="text-center">
                    {item?.status == 0 && <span className={'text-dark'}>Mới</span>}
                    {item?.status == 1 && <span className={'text-success'}>Xác nhận</span>}
                    {item?.status == 2 && <span className={'text-info'}>Nhập kho</span>}
                    {item?.status == -1 && <span className={'text-danger'}>Hủy</span>}
                </td>
                <td className="text-center">{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
            </tr>
        )
    }
    
    return (
        <Table className="mb-0 table-custom" responsive>
            <RenderHeadData />
            <RenderBobyData />
        </Table>
    )
}

const CustomerDebt = (props: any) => {
    const { data } = props
    const router = useHistory()

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-left" style={{ minWidth: 60}}>Mã phiếu</th>
                    <th className="text-left" style={{ minWidth: 60 }}>Loại phiếu</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày ghi công nợ</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Giá trị</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Khách hàng nợ</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        if (!data || data?.length === 0) {
            return <RowEmpty column={5} title="Chưa có dữ liệu công nợ nào!" />;
        }
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        const source:any = getDetailSource(item)
        const gotoDetail = (item:any) => {
            router?.push(source?.link)
        }
        
        
        const total = Number(item?.total || 0)
        const total_debt = Number(item?.total_debt || 0)
        return (
            <tr key={`${item?.id}-${index}`} onClick={() => gotoDetail(item)}>
                <td><Link to={source?.link}>{source?.code}</Link></td>
                <td>{source?.type_name}</td>
                <td className="text-center">{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td className="text-center">{PriceUtils.format(total , '') || '---'}</td>
                <td className="text-center">{PriceUtils.format(total_debt , '') || '---'}</td>
            </tr>
        )
    }
    
    return (
        <Table className="mb-0 table-custom" responsive>
            <RenderHeadData />
            <RenderBobyData />
        </Table>
    )
}

const CustomerTab = (props: any) => {
    const [tab, setTab] = useState('debt');
    let tabList = TABS
    tabList = tabList?.reduce((prev:any, item:any)=>{
        if(
            (item?.value !== 'debt' && !checkRole(props?.user?.roles, ['debtCustomer'], props?.user?.role)) &&
            (item?.value !== 'examination' && !checkRole(props?.user?.roles, ['viewListExamination'], props?.user?.role))
        ){
            
        }else{
            prev = [...prev, item]
        }
        return prev
    },[])

    if(tabList?.length === 0) return null
    return (
        <div className="card">
            <div className="card-body">
                <Row>
                    <Col md={8}>
                        <NavTabNutri
                            {...props}
                            tabList={tabList}
                            setTab={(tab: string) => setTab(tab)}
                            tab={tab || 'stock'}
                            classes="mt-3 mb-0 nav-tab-full"
                        />
                    </Col>
                    <Col md={4}>
                    {tab === 'debt' && checkRole(props?.user?.roles, ['debtCustomer'], props?.user?.role) &&
                        <div className="text-right">
                            <UncontrolledDropdown className="align-self-center">
                                <DropdownToggle
                                    data-toggle="dropdown"
                                    tag="button"
                                    className="btn btn-link p-0 dropdown-toggle mr-0">
                                        <Button color="success" className="ml-2">
                                            <i className='uil uil-plus mr-1'></i> Tạo phiếu thu/chi
                                        </Button>
                                </DropdownToggle>
                                <DropdownMenu right className="topbar-dropdown-menu profile-dropdown-items">
                                    <div className="dropdown-item notify-item" onClick={() => props?.handleActionModal({type: 'addReceipts', data: {}})}>
                                        <span>Phiếu thu</span>
                                    </div>
                                    <DropdownItem divider />
                                    <div className="dropdown-item notify-item" onClick={() => props?.handleActionModal({type: 'addPayment', data: {}})}>
                                        <span>Phiếu chi</span>
                                    </div>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    }
                    </Col>
                </Row>
                <div className="mt-4">
                    {tab === 'debt' && checkRole(props?.user?.roles, ['debtCustomer'], props?.user?.role) && <CustomerDebt {...props} data={props?.customer_debts}/>}
                    {tab === 'examination' && checkRole(props?.user?.roles, ['viewListExamination'], props?.user?.role) && <CustomereExamination {...props} data={props?.stock_imports}/>}
                </div>
            </div>
        </div>
    )
}

export default CustomerTab